import { DataKeys } from "../../types";
import { useLang } from "../Context";
import { TextBulletList } from "../display/TextFormat";
import { SlideInAnim } from "../tools/Animations";
import { HealthSection } from "./HealthSection";
import { HealthSectionHeader } from "./HealthSectionHeader";
import { getLocalized, HealthLang, LocalizedString } from "./healthTypes";
import { healthCol, healthColStack, healthSplitLg } from "./healthLayout";
import { HEALTH_BG_GREY, healthBody } from "./healthVisualStyles";

const imagePath = "image/health/";

interface HealthUnitIntroProps {
    data: DataKeys;
}

export function HealthUnitIntro({ data }: HealthUnitIntroProps) {
    const { lang } = useLang();
    const hLang = lang as HealthLang;
    const title = getLocalized(data?.title, hLang);
    const body = getLocalized(data?.body, hLang);
    const bullets: string[] = (data?.bullets ?? []).map((b: DataKeys) =>
        getLocalized(b as LocalizedString, hLang)
    );
    const sectionId = "unit-intro";
    const imageName = data?.image as string | undefined;

    return (
        <HealthSection
            id={sectionId}
            ariaLabelledBy={`${sectionId}-title`}
            style={{ backgroundColor: HEALTH_BG_GREY }}
        >
            <div className={`${healthSplitLg} lg:items-start`}>
                <div className={`${healthCol} flex flex-col gap-8`}>
                    <HealthSectionHeader
                        title={title}
                        titleId={`${sectionId}-title`}
                        className="mb-0 lg:mb-0"
                    />
                    <div className={`${healthColStack}`}>
                        <p className={healthBody}>{body}</p>
                        {bullets.length > 0 && (
                            <TextBulletList
                                list={bullets}
                                textStyle="text-left text-base text-grey-400"
                            />
                        )}
                    </div>
                </div>
                <div className={healthCol}>
                    {imageName && (
                        <SlideInAnim direction="right">
                            <div className="w-full overflow-hidden rounded-2xl">
                                <div className="aspect-[4/3] w-full lg:max-h-[420px]">
                                    <img
                                        src={require(`../../${imagePath}${imageName}`)}
                                        alt={title}
                                        className="h-full w-full rounded-2xl object-cover"
                                        loading="lazy"
                                    />
                                </div>
                            </div>
                        </SlideInAnim>
                    )}
                </div>
            </div>
        </HealthSection>
    );
}
